import formatTime from '@/utils/common.js';
import dayjs from 'dayjs';
import { Message } from 'element-ui';
/// 显示可复制的消息
export function showCopiableMessage(messenger, msg, textToCopy, timeout = 5000) {
    messenger({
        dangerouslyUseHTMLString: true,
        message: `<div><span>${msg}</span><a id="copyTraNo" href='#' style='color: #11bec1; margin-left: 20px;'>复制</a></div>`,
        type: 'success',
        duration: timeout
    });
    document.getElementById('copyTraNo').addEventListener('click', () => {
        copyText(messenger, textToCopy);
    });
}

export function copyText(messenger, textToCopy) {
    const input = document.createElement('input');
    input.type = 'text';
    input.value = textToCopy.trim();
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
    messenger.success(`‘${input.value}’复制成功`);
}

export function formatParams (params) {
    // 处理"创建时间"
    if (params.createTime && params.createTime.length > 0) {
        params.startTime = formatTime.formatDateTime(params.createTime[0]);
        params.endTime = formatTime.formatDateTime(params.createTime[1]);
    } else if (!params.createTime) {
        params.startTime = '';
        params.endTime = '';
    }
    const startTime = dayjs(params.startTime).valueOf() || 0;
    const endTime = dayjs(params.endTime).valueOf() || 0;
    const differenceValue = endTime - startTime;
    const maxDay32 = 1000 * 60 * 60 * 24 * 32;
    if (differenceValue > maxDay32) {
        Message.warning('按时间查询或导出时，查询或导出时间跨度不可超过一个月！');
        return false;
    }
    if (!params.customerOrderNo && !params.trainNum && !params.lineCode && !params.createTime) {
        Message.warning('发车单号、排单编号、客户订单号、创建时间不可同时为空');
        return false;
    }

    params.siteCode ? params.siteCodes = params.siteCode.split(',') : params.siteCodes = [];
    params.customerOrderNo ? params.customerOrderNoList = params.customerOrderNo.split(',') : params.customerOrderNoList = [];
    params.trainNum ? params.trainNumList = params.trainNum.split(',') : params.trainNumList = [];
    params.receiverDistrictCode ? params.receiverDistrictCodeList = params.receiverDistrictCode.split(',') : params.receiverDistrictCodeList = [];
    if (params.customerOrderNoList.length > 100) {
        Message.warning('客户订单号批量查询时，最多只能同时查100条数据！');
        return false;
    }

    delete params.createTime;
    delete params.customerOrderNo;
    delete params.trainNum;
    delete params.siteName;
    delete params.siteCode;
    delete params.receiverDistrictCode;
    delete params.receiverDistrictName;
    return params;
}

// 处理时间跨度大于一个月
export function manageMonth(startTime, endTime) {
    const timeCompare = new Date(endTime).getTime() - new Date(startTime).getTime();
    const start = dayjs().subtract(1, 'months').format('YYYY-MM-DD') + ' 00:00:00';
    const end = dayjs().format('YYYY-MM-DD') + ' 23:59:59';
    const newTimeCompare = new Date(end).getTime() - new Date(start).getTime();
    if (timeCompare > newTimeCompare) {
        return true;
    } else {
        return false;
    }
}
